export const URL = '/v2/pms/accomodations/:id/room_categories/:categoryId/undelete/'
